import authLoader from '../../routes/authLoader';
import ContactPage from './ContactPage';

export const helpRoutes = [
  {
    path: 'contact',
    element: <ContactPage />,
    loader: authLoader,
  },
];
